module App {
    export interface IHttpHelper {

        get<T>(url: string, postValues?: any, extraHeaders?: { [key: string]: any }, extraProperties?: { [key: string]: any }): ng.IPromise<T>;
        post<T>(url: string, postValues?: any, extraHeaders?: { [key: string]: any }, extraProperties?: { [key: string]: any }): ng.IPromise<T>;
        makeCall<T>(url: string, method: string, postValues?: any, extraHeaders?: { [key: string]: any }, extraProperties?: { [key: string]: any }): ng.IPromise<T>;
    }
}
